const $ = window.jQuery;
const $window = window.$window || $(window);

/**
 * Disable the first element of Select drop downs.
 * Limited to Contact Form 7 to avoid breakages
 */
const SelectOptions = {

    init() { 

        $('.wpcf7-form-control-wrap select option:first-child').attr('disabled', 'disabled');

        $("#mfcf7_zl_add_file").attr("value", "Choose multiple files");
    }
};

export default SelectOptions;